const RICOS_VERSION = "10.125.0";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
